import { ActionType } from './types'
import type { GetCountriesResponse } from './types'

import { createApiCall } from 'services'

import { call, put, fork, takeLatest } from 'redux-saga/effects'

import { ActionCallback } from '../model'

export function* getCountriesSaga(): Generator {
  yield takeLatest(ActionType.GET_COUNTRIES, function* (action: ActionCallback) {
    try {
      const { callback } = action

      const response: GetCountriesResponse = yield call(createApiCall, {
        url: '/common/countries',
      })

      const { data, status } = response

      if (status === 200) {
        yield put({
          type: ActionType.SET_COUNTRIES,
          payload: data.data,
        })
      }

      if (callback) {
        callback({ content: data, success: status === 200 })
      }
    } catch (error) {
      console.error(error)
    }
  })
}

export default [fork(getCountriesSaga)]
